var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"DotPagination text-center"},_vm._l((_vm.numberOfPages),function(idx){return _c('div',{staticClass:"PageItem",class:[{ Active: _vm.page === idx }],on:{"click":function($event){_vm.page === idx ? undefined : _vm.$emit('pageSelected', idx)}}})}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }